<template>
    <Transition name="fade">
        <ChatWaitingMessage v-if="shown" :messages="messages" />
    </Transition>
</template>

<script setup>
import { onMounted, ref } from "vue";

import ChatWaitingMessage from "./ChatWaitingMessage.vue";

defineProps({
    messages: {
        type: Array,
        default: () => [],
    },
});

const shown = ref(false);

onMounted(() => {
    // Fade in the thinking message
    shown.value = true;
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 300ms ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
